const advantages = [
  {
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20small%20warehouse%20building%20with%20cardboard%20boxes%20and%20shipping%20pallets%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=6&orientation=squarish",
    title: "工廠直供",
    desc: "直連源頭工廠，省去中間商差價，分銷商獲得最低進貨成本，利潤空間最大化。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20small%20airplane%20flying%20over%20a%20globe%20with%20shipping%20route%20lines%2C%20warm%20emerald%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=7&orientation=squarish",
    title: "跨境直郵",
    desc: "覆蓋全球主要市場，穩定的跨境物流合作，快速發貨，讓您的客戶滿意。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20cloud%20storage%20symbol%20with%20floating%20boxes%20and%20a%20small%20hand%20cursor%20clicking%2C%20warm%20sky%20blue%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=8&orientation=squarish",
    title: "零庫存模式",
    desc: "無需囤貨，下單後由我們代為發貨，分銷商只需專注銷售，輕鬆創業。",
  },
  {
    image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20shield%20badge%20with%20checkmark%20and%20small%20star%20rating%2C%20warm%20rose%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=9&orientation=squarish",
    title: "品質把關",
    desc: "嚴格品控流程，每批商品均經過質量檢驗，售後問題由平台統一處理。",
  },
];

export default function AdvantageSection() {
  return (
    <section className="py-16 px-6 lg:px-12 bg-stone-50">
      <div className="text-center mb-12">
        <span className="inline-block bg-amber-100 text-amber-700 text-xs font-semibold px-3 py-1 rounded-full mb-3">
          為什麼選擇吉時
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
          分銷賺錢，從這裡開始
        </h2>
        <p className="text-gray-500 text-sm mt-2 max-w-md mx-auto">
          不用開店、不用囤貨，零成本就能開始跨境分銷
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {advantages.map((adv) => (
          <div
            key={adv.title}
            className="bg-white rounded-xl p-6 border border-gray-100 hover:border-amber-200 transition-all duration-300 group"
          >
            <div className="w-14 h-14 rounded-full overflow-hidden bg-stone-50 ring-1 ring-gray-100 mb-4 group-hover:ring-amber-300 group-hover:scale-110 transition-all duration-300">
              <img
                src={adv.image}
                alt={adv.title}
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-gray-900 font-semibold mb-2">{adv.title}</h3>
            <p className="text-gray-500 text-sm leading-relaxed">{adv.desc}</p>
          </div>
        ))}
      </div>

      {/* Process */}
      <div className="mt-14">
        <h3 className="text-center text-lg font-bold text-gray-800 mb-8">四步開始分銷</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { step: "01", image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20user%20profile%20card%20with%20avatar%20and%20checkmark%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=10&orientation=squarish", title: "註冊帳號", desc: "填寫基本資料，30 秒完成註冊" },
            { step: "02", image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20magnifying%20glass%20over%20a%20product%20grid%20with%20small%20star%20ratings%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=11&orientation=squarish", title: "挑選商品", desc: "瀏覽萬款商品，選擇心儀貨源" },
            { step: "03", image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20shopping%20cart%20with%20a%20small%20package%20box%20and%20a%20checkmark%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=12&orientation=squarish", title: "儲值下單", desc: "客戶下單後，平台代為發貨" },
            { step: "04", image: "https://readdy.ai/api/search-image?query=A%20minimal%203D%20isometric%20illustration%20of%20a%20small%20stack%20of%20gold%20coins%20with%20a%20rising%20arrow%20and%20a%20wallet%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20clean%20white%20background%2C%20soft%20shadows%2C%20modern%20UI%20icon%20style%2C%20high%20quality%203D%20render%2C%20cute%20and%20friendly%20aesthetic%2C%20clean%20design&width=200&height=200&seq=13&orientation=squarish", title: "賺取差價", desc: "收取差價，輕鬆獲得收益" },
          ].map((item, idx) => (
            <div key={item.step} className="relative flex flex-col items-center text-center">
              {idx < 3 && (
                <div className="hidden md:block absolute top-6 left-[calc(50%+28px)] right-0 h-px border-t-2 border-dashed border-amber-200"></div>
              )}
              <div className="w-12 h-12 rounded-full overflow-hidden bg-amber-50 ring-1 ring-amber-100 mb-3 relative z-10">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="text-xs text-amber-500 font-bold mb-1">STEP {item.step}</div>
              <div className="text-sm font-semibold text-gray-800 mb-1">{item.title}</div>
              <div className="text-xs text-gray-500">{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}